// The date picker windows are anchored on today; nav-arrow movements that
// would push the active selection outside this range are forbidden so the
// picker UI can always display and edit the current selection.
export const YEARS_BACK = 20
export const YEARS_FORWARD = 20
export const MAX_MONTHS_BACK = YEARS_BACK * 12
export const MAX_MONTHS_FORWARD = YEARS_FORWARD * 12
